import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material"
import { ChartDemandContainer } from "./containers/ChartDemandContainer"
import { ChartMedianPriceContainer } from "./containers/ChartMedianPriceContainer"
import { ChartSupplyContainer } from "./containers/ChartSupplyContainer"
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { DateTime } from "luxon"
import { ChartCompetitorListContainer } from "./containers/ChartCompetitorListContainer"

interface GraphsSectionProps {
    marketSpyId?: number
    marketSpyRunResult?: any
}

export const GraphsSection = (props: GraphsSectionProps): JSX.Element => {
    const {
        marketSpyId,
        marketSpyRunResult
    } = props


    const renderAccordionSummaryHeading = () => {
        if (marketSpyRunResult !== undefined && marketSpyRunResult?.checkinUtc !== undefined) {
            return (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Typography sx={
                        {
                            fontSize: {
                                xs: '24px',
                                sm: '24px',
                                md: '24px',
                            },
                            lineHeight: '28px',
                            color: '#000',
                            fontWeight: 600,
                            marginRight: 2
                        }
                    }
                    >
                        Look Ahead Graphs This is how the market will be in future "real time data"

                    </Typography>
                </Box>
            )
        }
    }

    return (
        <>
            <Accordion
                disabled={marketSpyRunResult === undefined}           
                disableGutters
                defaultExpanded={true}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: '#FFF' }} />}
                    aria-controls="panel1a-content"
                    sx={{
                        backgroundColor: '#FFF',
                        flexDirection: 'row-reverse',
                        padding: {
                            xs: '8px 12px', md: '8px 24px'
                        },
                        '& .MuiAccordionSummary-expandIconWrapper': {
                            padding: '12px 12px 12px 12px',
                            fill: '#717171',
                            color: '#717171'
                        },

                        '& .MuiSvgIcon-root': {
                            fill: '#717171',
                            color: '#717171'
                        },

                        '& .MuiAccordionSummary-content': {
                            flexDirection: {
                                xs: 'column',
                                sm: 'row'
                            }
                        },

                    }}
                >
                    {renderAccordionSummaryHeading()}
                </AccordionSummary>
                <AccordionDetails sx={{ bgcolor: '#EEE', p: 2 }}>
                    <Box sx={{
                        display: 'grid',
                        gap: {
                            xs: '20px',
                            md: '30px'
                        },
                        gridTemplateColumns: {
                            xs: '100%',
                            md: '1fr 1fr'
                        }
                    }}>
                        <ChartMedianPriceContainer
                            monitorId={marketSpyId}
                        />
                        <ChartSupplyContainer
                            monitorId={marketSpyId}
                        />
                        <ChartDemandContainer
                            monitorId={marketSpyId}
                        />
                        <ChartCompetitorListContainer
                            monitorId={marketSpyId}
                        />
                    </Box>
                </AccordionDetails>
            </Accordion>
        </>
    )
}
